/**
 * @returns null if string is not parseable
 */
export function jsonParse(str) {
  try {
    return JSON.parse(str);
  } catch ($ex) {
    return null;
  }
}



// WEBPACK FOOTER //
// ./client/app/shared/utils/string.utils.js